import { createContext } from "react";

import type { TMessageContext, TSetMessageParams } from "./types";

export const MessageContext = createContext<TMessageContext>({ message: "", props: {}, messageNo: 0 });
export const MessageActionContext = createContext<(message: TSetMessageParams) => void>(() => {});
